module.exports = __webpack_public_path__ + "static/media/trip_details_header.220a7858.png";